import { Container, Card } from "react-bootstrap";

export default function NoLoanCard() {
  return (
    <Container fluid className="py-2">
      <h1 className="text-2xl fw-bolder my-4">Dashboard</h1>
      <Card className="p-4 my-4 text-center">
        Loan is not active yet
      </Card>
    </Container>
  );
}
